import { PixelRatio } from "react-native";

interface CdnImagesProps {
  readonly imageUrl: string;
  readonly width: number;
  readonly crop?: boolean;
}

const cdnImageUrl = ({ imageUrl, width, crop }: CdnImagesProps): string => {
  const dpi = PixelRatio.get();
  return `${imageUrl}?w=${Math.ceil(width * (dpi > 1 ? 1.5 : 1))}&f=auto${crop ? "&c=1" : ""}`;
};

export { cdnImageUrl };
